import { workspaces, languageWorkspaceOptions } from '../config';

/**
 * Gets the language and workspace from a combo ID.
 * @param {string} comboId - The combo ID (e.g., 'he_ofek', 'en_ivritil')
 * @returns {{ lang: string, workspace: string }} The language and workspace
 */
export const getLangAndWorkspace = (comboId) => {
    const option = languageWorkspaceOptions.find(opt => opt.id === comboId);
    if (option) {
        return { lang: option.lang, workspace: option.workspace };
    }
    // Default to first option
    return { lang: languageWorkspaceOptions[0].lang, workspace: languageWorkspaceOptions[0].workspace };
};

/**
 * Gets the combo ID from language and workspace.
 * @param {string} lang - The language
 * @param {string} workspace - The workspace
 * @returns {string} The combo ID
 */
export const getComboId = (lang, workspace) => {
    const option = languageWorkspaceOptions.find(opt => opt.lang === lang && opt.workspace === workspace);
    return option ? option.id : languageWorkspaceOptions[0].id;
};

/**
 * Maps a language ID to its corresponding workspace (legacy support).
 * For combo IDs, extracts the workspace. For legacy lang IDs, uses mapping.
 * @param {string} langOrComboId - The language ID or combo ID
 * @returns {string} The workspace name
 */
export const getWorkspaceByLang = (langOrComboId) => {
    // Check if it's a combo ID first
    const option = languageWorkspaceOptions.find(opt => opt.id === langOrComboId);
    if (option) {
        return option.workspace;
    }
    // Legacy mapping for backward compatibility
    const legacyMap = {
        'he': 'ofek',
        'ar': 'ofek',
        'en': 'ofek'
    };
    const workspace = legacyMap[langOrComboId];
    if (workspace && workspaces.includes(workspace)) {
        return workspace;
    }
    return workspaces[0];
};

export const stringScoreNormalizer = (str) => {
    let _str = str.replace(/[\u0591-\u05C7]/g, '');                                         // remove Hebrew score from string
    _str = _str.replace(/[\u0610-\u061A\u0640\u064B-\u065F\u0670\u06D6-\u06ED]/gi, '');     // remove Arabic score from string

    return _str;
};